<template>
  <template v-if="hasDescription || hasActivities">
    <SSection :desktop-full="true" :title="t('views.cottage.activities')">
      <div v-if="hasActivities" class="grid grid-cols-2 lg:grid-cols-4 gap-x-6">
        <div
          v-for="(group, indexGroup) in item.activityDetail.activityGroups"
          :key="indexGroup"
        >
          <TText size="base" variant="semibold" classes="mb-2" tag="h3">
            {{ group.name }}
          </TText>

          <TProse :full-width="false" :responsive="false">
            <ul>
              <li
                v-for="(activity, indexActivity) in group.activities.map(
                  activity => activity.name,
                )"
                :key="indexActivity"
              >
                {{ activity }}
              </li>
            </ul>
          </TProse>
        </div>
      </div>

      <TText v-if="hasDescription" tag="div" classes="mb-0">
        <div v-html="item.activityDetail.description" />
      </TText>
    </SSection>
  </template>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'

type itemType = Pick<CottagePage, 'activityDetail'>

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const hasDescription =
  props.item.activityDetail.description !== null &&
  props.item.activityDetail.description.length > 0
const hasActivities = props.item.activityDetail.activityGroups.length > 0
</script>
